import * as React from 'react';

type Props = {
  children: React.ReactNode | Array<React.ReactNode>;
};

export default function UnorderedList(props: Props) {
  let { children } = props;

  return (
    <ul className="list-disc pl-6">
      {React.Children.map(children, child => {
        return <li className="my-2">{child}</li>;
      })}
    </ul>
  );
}
